import { EventInteractions } from '@eventbrite/ads';
import { EVENT_INTERACTION, FormattedEvent } from '@eventbrite/event-renderer';
import { useQueryClient } from '@tanstack/react-query';
import cloneDeep from 'lodash/cloneDeep';
import { SearchApiResponse } from '../../../../redux/api/search';
import { EventSearch } from '../../../../types';
import { getEventSearchQueryKey } from '../../SearchPageData';

export function useRemoveEvent(eventSearch: EventSearch) {
    const client = useQueryClient();

    return {
        removeEvent: (eventId: string) => {
            client.setQueryData<SearchApiResponse>(
                getEventSearchQueryKey(eventSearch),
                (apiResponse) => {
                    if (!apiResponse) {
                        return apiResponse;
                    }

                    const promotedEvents =
                        apiResponse.data.events.promoted_results;

                    const newApiResponse = cloneDeep(apiResponse);
                    newApiResponse.data.events.promoted_results =
                        promotedEvents.filter(({ id }) => eventId !== id);

                    return newApiResponse;
                },
            );
        },
    };
}

export enum PromotedActions {
    hideAd = EventInteractions.HideAd,
    reportAd = EventInteractions.ReportAd,
}

export function sendActionMetrics(
    event: FormattedEvent,
    action: PromotedActions,
    element: React.RefObject<HTMLSpanElement>,
) {
    const interactionEvent = new CustomEvent(EVENT_INTERACTION, {
        detail: {
            id: event.id,
            action,
            event,
        },
        bubbles: true,
    });

    element.current?.dispatchEvent(interactionEvent);
}
